declare namespace $ {

	type $mol_view__sub_rise_range_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_rise_range_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_rise_range_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_rise_range_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $rise_range_input__disabled_rise_range_5 = $mol_type_enforce<
		ReturnType< $rise_range['disabled'] >
		,
		ReturnType< $rise_range_input['disabled'] >
	>
	type $rise_range_input__min_rise_range_6 = $mol_type_enforce<
		ReturnType< $rise_range['min'] >
		,
		ReturnType< $rise_range_input['min'] >
	>
	type $rise_range_input__max_rise_range_7 = $mol_type_enforce<
		ReturnType< $rise_range['max'] >
		,
		ReturnType< $rise_range_input['max'] >
	>
	type $rise_range_input__step_rise_range_8 = $mol_type_enforce<
		ReturnType< $rise_range['step'] >
		,
		ReturnType< $rise_range_input['step'] >
	>
	type $rise_range_input__value_rise_range_9 = $mol_type_enforce<
		ReturnType< $rise_range['value'] >
		,
		ReturnType< $rise_range_input['value'] >
	>
	type $rise_range_input__event_input_rise_range_10 = $mol_type_enforce<
		ReturnType< $rise_range['event_input'] >
		,
		ReturnType< $rise_range_input['event_input'] >
	>
	type $rise_range_value__sub_rise_range_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $rise_range_value['sub'] >
	>
	type $rise_range_value__disabled_rise_range_12 = $mol_type_enforce<
		ReturnType< $rise_range['disabled'] >
		,
		ReturnType< $rise_range_value['disabled'] >
	>
	type $mol_view__sub_rise_range_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $rise_range extends $mol_view {
		label_min( ): string
		Min( ): $mol_view
		label_medium( ): string
		Medium( ): $mol_view
		label_max( ): string
		Max( ): $mol_view
		Labels( ): $mol_view
		disabled( ): boolean
		min( next?: number ): number
		max( next?: number ): number
		step( next?: number ): number
		value( next?: number ): number
		event_input( next?: any ): any
		Input( ): $rise_range_input
		Value( ): $rise_range_value
		Current( ): $mol_view
		percent( ): string
		minimal_height( ): number
		unit( ): string
		medium( next?: number ): number
		enabled( ): boolean
		sub( ): readonly(any)[]
		attr( ): ({ 
			'disabled': ReturnType< $rise_range['disabled'] >,
		})  & ReturnType< $mol_view['attr'] >
		style( ): ({ 
			'--rise_range_percent': ReturnType< $rise_range['percent'] >,
		})  & ReturnType< $mol_view['style'] >
	}
	
	export class $rise_range_input extends $mol_view {
		disabled( ): boolean
		min( next?: number ): number
		max( next?: number ): number
		step( next?: number ): number
		value( next?: number ): number
		event_input( next?: any ): any
		dom_name( ): string
		attr( ): ({ 
			'type': string,
			'disabled': ReturnType< $rise_range_input['disabled'] >,
		})  & ReturnType< $mol_view['attr'] >
		field( ): ({ 
			'min': ReturnType< $rise_range_input['min'] >,
			'max': ReturnType< $rise_range_input['max'] >,
			'step': ReturnType< $rise_range_input['step'] >,
			'value': ReturnType< $rise_range_input['value'] >,
		})  & ReturnType< $mol_view['field'] >
		event( ): ({ 
			input( next?: ReturnType< $rise_range_input['event_input'] > ): ReturnType< $rise_range_input['event_input'] >,
		})  & ReturnType< $mol_view['event'] >
	}
	
	export class $rise_range_value extends $mol_view {
		disabled( ): boolean
		attr( ): ({ 
			'disabled': ReturnType< $rise_range_value['disabled'] >,
		})  & ReturnType< $mol_view['attr'] >
	}
	
}

//# sourceMappingURL=range.view.tree.d.ts.map